/**************************************************
 * Nombre:       BarraAparece
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Slide} from "@mui/material";
import {useEffect, useState} from "react";
import BarraPc from "./BarraPc";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import BarraCell from "./BarraCell";
import {obtenerSeccion} from "../../Utilidades/obtenerSeccion";
import {useLocation} from "react-router";

const BarraAparece = () => {
    const location = useLocation()
    const {masSM} = useResponsive()
    const [showNavbar, setShowNavbar] = useState(false);

    useEffect(() => {

        let rutas = ['Checkout']
        let sec = obtenerSeccion(location.pathname)

        const handleScroll = () => {
            // Si el scroll es mayor a 100px, mostramos la barra
            if (window.scrollY > 200) {
                setShowNavbar(!rutas.includes(sec));
            }
            // Si el scroll vuelve a 0, la ocultamos
            else if (window.scrollY < 100) {
                setShowNavbar(false);
            }
        };

        window.addEventListener('scroll', handleScroll);


        return () => window.removeEventListener('scroll', handleScroll);
    }, [location]);


    return (
        <Slide appear={false} direction="down" in={showNavbar}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: '#000000',
                    position: 'fixed',
                    top: 0,
                }}
            >

                {masSM ?
                    <BarraPc mostrar={!showNavbar}/>
                    :
                    <BarraCell mostrar={!showNavbar}/>
                }


            </Grid>
        </Slide>
    );

}
export default BarraAparece  